import React from 'react'
import { IslandState } from '../../Common/SI'
import { useFilters } from '../../Common/Hooks/useFilters'

export interface IslandStateLinkProps {
	islandState: IslandState
}

export function IslandStateLink(props: IslandStateLinkProps): JSX.Element {

	const { addFilter } = useFilters()

	return (
		<React.Fragment>
			{
				!props.islandState.healthy
					// eslint-disable-next-line jsx-a11y/anchor-is-valid
					? <a className='filter' href='#' onClick={(e) => {
						e.preventDefault()
						addFilter('islandStates', `Healthy`)
					}}>Blighted</a>
					: props.islandState.blightCards.length > 0
						// eslint-disable-next-line jsx-a11y/anchor-is-valid
						? <a className='filter' href='#' onClick={(e) => {
							e.preventDefault()
							addFilter('islandStates', `Healthy`)
						}}>Still Healthy</a>
						// eslint-disable-next-line jsx-a11y/anchor-is-valid
						: <a className='filter' href='#' onClick={(e) => {
							e.preventDefault()
							addFilter('islandStates', `Blighted`)
						}}>Healthy island</a>
			}
		</React.Fragment>
	)
}
